module.exports = __webpack_public_path__ + "static/media/vitejs.64d68c9e.svg";